import { render } from "./ResourceItem.vue?vue&type=template&id=f784dd2c"
import script from "./ResourceItem.vue?vue&type=script&lang=js"
export * from "./ResourceItem.vue?vue&type=script&lang=js"

import "./ResourceItem.vue?vue&type=style&index=0&id=f784dd2c&lang=css"
script.render = render

export default script